import {
  ColDef,
  GetRowIdParams,
  GridOptions,
  ModelUpdatedEvent,
  SizeColumnsToContentStrategy,
  SizeColumnsToFitGridStrategy,
  SizeColumnsToFitProvidedWidthStrategy,
} from 'ag-grid-community';

import { NoNotificationsOverlayComponent } from './notifications-overlay/no-notifications-overlay.component';
import { ColumnHeaderComponent } from '@app/app/components/grid-components/column-header/column-header.component';
import { DynamicCellComponent } from './cell-components/dynamic-cell/dynamic-cell.component';

  export const notificationsDefaultMinWidth = 320;

  export const  COMPONENTS: { [p: string]: any; } = {
    agColumnHeader: ColumnHeaderComponent,
    dynamicTaskCell: DynamicCellComponent
  };

  export const AUTO_SIZE_STRATEGY:
    | SizeColumnsToFitGridStrategy
    | SizeColumnsToFitProvidedWidthStrategy
    | SizeColumnsToContentStrategy = {
    type: 'fitGridWidth',
    defaultMinWidth: notificationsDefaultMinWidth,
  };

  export const GRID_BASE_CONFIG: GridOptions = {
    noRowsOverlayComponent: NoNotificationsOverlayComponent,
    onModelUpdated: (event: ModelUpdatedEvent) => {
      event.api.getDisplayedRowCount() === 0 ?
        event.api.showNoRowsOverlay() :
        event.api.hideOverlay();
    },
    onFilterChanged: (event) => {
      event.api.sizeColumnsToFit(); 
    },
    headerHeight: 0,
    rowHeight: 84,
    animateRows: true,
    autoSizeStrategy: AUTO_SIZE_STRATEGY,
    autoSizePadding: 16,
    cacheQuickFilter: true,
    columnMenu: 'new',
    enableCellTextSelection: false,
    getRowId: (params: GetRowIdParams) => {
      return params.data.activityId;
    },
    popupParent: document.body,
    suppressAggFuncInHeader: true,
    suppressCellFocus: true,
    suppressRowClickSelection: false,
    suppressRowDeselection: true,
    components: COMPONENTS,
    includeHiddenColumnsInQuickFilter: true
  };

  export const GRID_BASE_DEFAULT_COL_DEF: ColDef = {
    suppressMovable: true,
    suppressHeaderFilterButton: false,
    suppressHeaderMenuButton: true,
    suppressHeaderContextMenu: true,
    filterParams: {
      maxNumConditions: 1
    }
  };
